module.exports = __webpack_public_path__ + "static/media/schedule-negative.7ea5fc47.svg";